import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { IProjectOption } from "Dashboard/domain/IProjectOption";
import { FilterOptionOption } from "react-select/dist/declarations/src/filters";

interface ProjectSelectForReceivableProps {
  onChange: (val: number | null) => void;
  customStyles: any;
  defaultValue?: number;
  scrollContainerRef?: any;
  error?: any;
  width?: number;
  isReadOnly?: boolean;
  preloadedOptions: IProjectOption[];
}

const ProjectSelectForReceivable = forwardRef<any, any>((props: ProjectSelectForReceivableProps, ref) => {
  const { defaultValue, onChange, customStyles, scrollContainerRef, error, width, isReadOnly, preloadedOptions } = props
  const [options, setOptions] = useState<IProjectOption[]>([]);
  const [value, setValue] = useState<IProjectOption | null>(null);

  useEffect(() => {
    try {
      setOptions(preloadedOptions.filter(
        (option: IProjectOption) => option.active));
    } catch (err) {
      console.log(err);
    }
  }, [preloadedOptions]);

  useEffect(() => {
    if (defaultValue) {
      const values = options.filter((o) => o.value === defaultValue);
      if (values[0]) {
        setValue(values[0]);
      } else setValue(null);
    }
  }, [defaultValue, options]);

  const handleChange = (newValue: IProjectOption | null, actionMeta: any) => {
    setValue(newValue);
    onChange(newValue ? newValue.value : null);
  };

  const customFilterOption = ({ label }: FilterOptionOption<IProjectOption>, input: string): boolean => {
    const inputWords = normalize(input).split(/\s+/);
    const labelWords = normalize(label).split(/\s+/);
    return inputWords.every(inputWord => {
      return labelWords.some(labelWord => labelWord.includes(inputWord));
    });
  };



  return <>
    {!isReadOnly ? (
      <Select
        styles={customStyles}
        menuPosition="fixed"
        closeMenuOnScroll={({ target }) => {
          if (!target || !(target instanceof HTMLElement)) return false;
          return target === scrollContainerRef?.current;
        }}
        ref={ref}
        options={options}
        value={value}
        onChange={handleChange}
        filterOption={customFilterOption}
        placeholder={""}
        noOptionsMessage={() => "Ne postoji"}
        {...{ error, dropdownIndicator: false, width }}
      />
    ) : (
      <input type="text" style={{ fontSize: "10px" }} className="bg-item-dark" value={value?.label ?? ''} readOnly />
    )}
  </>
});

const normalize = (str: string) => str.toLowerCase().replace(/[čćžđ]/g, m => (m === 'ž' ? 'z' : m === 'đ' ? 'dj' : 'c'));

export default ProjectSelectForReceivable;
